import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import {
    getFirestore,
    collection,
    addDoc,
    updateDoc
} from "firebase/firestore";
import {
    getStorage,
    ref,
    uploadBytes,
    getDownloadURL
} from "firebase/storage";
import { app, auth, } from "../firebase/firebase";
import { onAuthStateChanged } from "firebase/auth";
import placeholder from "../images/foto_placeholder.png";
import info from "../images/info_blau.svg";
import Loader from "../components/Loader";
import LoginInfo from "../components/LoginInfo";

export default function Post() {

    const [userState, setuserState] = useState(false);

    useEffect(() => {
        onAuthStateChanged(auth, user => {
            if (user) {
                setuserState(true)
            }
            else {
                setuserState(false);
            }
        })
    }, []);

    let refFoto = useRef(0);
    let refPreview = useRef(0);
    let refAddress = useRef();
    const db = getFirestore(app);
    const storage = getStorage(app);

    const navigate = useNavigate();
    // form actions
    const [lat, setLat] = useState(0);
    const [lng, setLng] = useState(0);
    const [address, setAddress] = useState("");

    // Modal stuff
    // Info Modal
    const [showInfo, setInfo] = useState(false);
    // Post success Modal
    const [modalHeader, setHeader] = useState("");
    const [modalText, setText] = useState("");
    const [showResult, setResult] = useState(false);

    // show Loader
    const [showLoader, setLoader] = useState(false);


    function resizeImage() {
        var _reader = new FileReader();
        const _file = refFoto.current.files[0];
        _reader.readAsDataURL(_file);
        _reader.onload = e => {
            var _imgUrl = e.target.result;
            if (_file.size > 1000000) {
                var _img = new Image();
                _img.src = _imgUrl;
                _img.onload = e2 => {
                    var _canvas = document.createElement("canvas");
                    var _scaleFactor = 1200 / e2.target.width;
                    _canvas.width = 1200;
                    _canvas.height = e2.target.height * _scaleFactor;

                    var _context = _canvas.getContext("2d");
                    _context.drawImage(e2.target, 0, 0, _canvas.width, _canvas.height);
                    _imgUrl = _context.canvas.toDataURL("image/jpeg", 0.8);
                    refPreview.current.src = _imgUrl
                }
            }
            else {
                refPreview.current.src = _imgUrl
            }
        }
    }
    // Get coordinates from address
    async function getCoords(a) {
        const _address = encodeURI(a);
        // ToDo: restrict access to poetica-westfalia.de or IP address
        fetch("https://maps.googleapis.com/maps/api/geocode/json?address=" + _address + "&key=AIzaSyB__VL7ShK1LJxTRQB3pGqGTcS6yh-mjmk")
            .then(response => response.json())
            .then(data => {
                if (data.results[0]) {
                    setLat(data.results[0].geometry.location.lat);
                    setLng(data.results[0].geometry.location.lng);
                }
                else {

                }
            })
            .catch(error => {
                alert("Koordinaten zur Adresse [" + _address + "] konnten nicht ermittelt werden. Fehler: " + error.message)
            })
    }
    // round coords to 5 digits to catch equal addresses
    function round(num, decimalPlaces) {
        var p = Math.pow(10, decimalPlaces);
        var n = (num * p) * (1 + Number.EPSILON);
        return Math.round(n) / p;
    }
    // Get address from geolocation
    async function getAddress() {

        if (navigator.geolocation) {

            navigator.geolocation.getCurrentPosition(pos => {
                setLat(pos.coords.latitude);
                setLng(pos.coords.longitude);
                fetch("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + pos.coords.latitude + ", " + pos.coords.longitude + "&key=AIzaSyB__VL7ShK1LJxTRQB3pGqGTcS6yh-mjmk")
                    .then(response => response.json())
                    .then(data => {
                        if (data.results[0]) {
                            setAddress(data.results[0].formatted_address);
                        }
                        else {
                            refAddress.current.placeholder = "Keine passende Adresse gefunden";
                        }
                    })
            }, error => {
                alert(error.message);
            }, {
                timeout: 5000,
                enableHighAccuracy: true
            }
            )
        }
        else {
            alert("Bitte erteile Deiner Browser-App die Erlaubnis, Deinen Standort abzurufen.")
        }
    }
    // Save poem to firestore
    function savePoem(formData) {
        // check, if address is on map
        if (lat >= 50.26 && lat <= 53.08 && lng >= 4.35 && lng <= 11.62) {
            setLoader(true)
        }
        else {
            alert("Die angegebene Adresse konnte auf der Karte nicht gefunden werden. Wenn Du die genaue Adresse nicht kennst, reicht es auch, nur einen Ortsnamen anzugeben, zum Beispiel 'Detmold' (muss in NRW liegen!). Nutze dann das Feld Beschreibung für nähere Angaben.");
            setAddress("");
            return
        }
        // todo: loader starten
        const poemData = {
            date: Date.now(),
            file: null,
            address: formData.get("poemAddress"),
            coords: [round(lat, 5), round(lng, 5)],
            description: formData.get("poemDescription"),
            event: formData.get("poemEvent"),
            sender: auth.currentUser.displayName,
            email: auth.currentUser.email
        }

        addDoc(collection(db, "poems"), poemData)
            .then(docRef => {
                const storageRef = ref(storage, docRef.id);
                fetch(refPreview.current.src)
                    .then(res => res.blob())
                    .then(blob => {
                        uploadBytes(storageRef, blob)
                            .then(snapshot => {
                                getDownloadURL(storageRef).then(url =>{
                                    updateDoc(docRef, {
                                        file: url
                                    })
                                }).catch(e => console.log(e.message));
                                setLoader(false);
                                window.alert("Prima! Dein Poem wurde erfolgreich gespeichert.");
                                navigate("/map", { state: { lat: poemData.coords[0], lng: poemData.coords[1] } })
                            })
                            .catch(e => {
                                setLoader(false);
                                setHeader("Fehler!");
                                setText("Dein Poem konnte nicht gespeichert werden.<br/>Fehler: " + e.message);
                                setResult(true);
                            })
                    });
            })
            .catch(e => alert(e.message))
    }

    // return
    return (
        <div className="page-class">
            <h1>Poem melden</h1>
            {!userState?<LoginInfo />:<></>}
            <form action={savePoem}>
                <div className="mb-3">
                    <label htmlFor="poemFoto" className="btn btn-primary">Foto hochladen</label>
                    <input type="file" ref={refFoto} name="poemFoto" className="d-none" accept="image/*" id="poemFoto" onChange={resizeImage} />
                </div>
                <div className="mb-3">
                    <img src={placeholder} ref={refPreview} id="uploadPreview" alt="" />
                </div>
                <div className="mb-3">
                    <label htmlFor="poemAddress" className="form-label">Adresse</label>
                    <input type="text" defaultValue={address} name="poemAddress" className="form-control" placeholder="Straße Nummer, Ort" onBlur={e => getCoords(e.target.value)} required />
                </div>

                oder <br /><br />
                <div className="mb-3">
                    <div className="mb-3">
                        <button type="button" className="btn btn-primary" onClick={getAddress}>Standort bestimmen</button><img src={info} className="info-icon" alt="" onClick={() => setInfo(true)} />
                    </div>
                    <Modal show={showInfo} onHide={() => setInfo(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Information</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Um die Standort-Funktion nutzen zu können, muss poetica-westfalia.de auf den Standort Deines Handys zugreifen dürfen. (Eine Anleitung dazu findest Du z. B. <a href="https://support.google.com/chrome/answer/142065?hl=de&co=GENIE.Platform%3DAndroid" target="_blank" rel="noreferrer">hier</a>.)<br /><br />
                            ACHTUNG: Die Standort-Bestimmung kann ungenau sein. Bitte überprüfe die errechnete Adresse im Feld darüber und korrigiere sie gegebenenfalls.
                        </Modal.Body>
                    </Modal>
                </div>
                <div className="mb-3">
                    <label htmlFor="poemDescription" className="form-label">Beschreibung</label>
                    <textarea name="poemDescription" className="form-control" cols="30" rows="4" placeholder="Teile uns hier gerne den Text mit und gib eine kurze Beschreibung, z. B.: Psalm auf Torbogen oder: Reim auf Klotür oder: Liebesgedicht von unbekannt" required></textarea>
                </div>
                <div className="mb-5">
                    <label htmlFor="poemEvent" className="form-label">Geeignet für</label>
                    <input type="text" name="poemEvent" className="form-control" placeholder="z. B.: Familienausflug, romantisches Date, Wandertag" />
                </div>
                <div className="mb-2 d-flex flex-row">
                    <button type="submit" className="btn btn-primary">Absenden</button>{showLoader && <Loader />}
                </div>
            </form>
            <Modal show={showResult} onHide={() => setResult(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalHeader}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalText}</Modal.Body>
            </Modal>
        </div>
    );

}